import "./PaymentDetails.scss"
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Typography
} from "@mui/material"
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import { CreditCardList, UserData } from "../../../types/userTypes"
import { useTranslationLabel } from "../../../hooks/useTranslationLabel"
import { FC } from "react"
import { useAppDispatch, useAppSelector } from "../../../redux/hooks"
import { ModalTypes, showModal } from "../../../redux/slices/modalSlice"
import { useIsMobile } from "../../../hooks/useIsMobile"
import { getUserAsync, selectUserData } from "../../../redux/slices/authSlice"
import CredoraxClass from "../../../redux/api/CredoraxClass"
import { showAlert } from "../../../redux/slices/alertSlice"
const apiBaseUrl = import.meta.env.VITE_API_BASE_URL

type PaymentDetailsTableProps = {
  creditCardList: CreditCardList[]
}

export const PaymentDetails: FC<PaymentDetailsTableProps> = ({
  creditCardList,
}) => {
  const isMobile = useIsMobile()
  const userData: UserData | null = useAppSelector(selectUserData)
  const dispatch = useAppDispatch()
  const {
    PAYMENT_DETAILS_TITLE,
    PAYMENT_ADD_CARD_BTN,
    PAYMENT_TABLE_NUMBER,
    PAYMENT_TABLE_VALIDITY,
    PAYMENT_TABLE_PRIMARY,
    PAYMENT_TABLE_ACTIVE,
    PAYMENT_TABLE_ACTIONS,
    REQ_FAILD,
    REQ_SUCCESS,
    SET_AS_PRIMARY,
    DEACTIVATE,
    ACTIVATE,
  } = useTranslationLabel()

  const customer = {
    customerToken: localStorage.getItem("x-Customer") || "",
    loginToken: localStorage.getItem("x-Token") || "",
  }

  const Credorax = new CredoraxClass(
    customer,
    "https://ppskey-int.credorax.com/keypayment/rest/v2/store",
    apiBaseUrl + "/",
  )

  const setDefualt = async (paymentMethodId: number) => {
    const res = await Credorax.updateCreditCard({
      paymentMethodId,
      accountId: userData?.accountDetails.accountId || null,
      isDefault: true,
    })

    if (res === true) {
      dispatch(getUserAsync())
      dispatch(
        showAlert({
          text: REQ_SUCCESS,
          type: "success",
        }),
      )
    } else {
      dispatch(
        showAlert({
          text: REQ_FAILD,
          type: "error",
        }),
      )
    }
  }

  const setActive = async (paymentMethodId: number, value: boolean) => {
    const res = await Credorax.updateCreditCard({
      paymentMethodId,
      accountId: userData?.accountDetails.accountId || null,
      isActive: value,
    })

    if (res === true) {
      dispatch(getUserAsync())
      dispatch(
        showAlert({
          text: REQ_SUCCESS,
          type: "success",
        }),
      )
    } else {
      dispatch(
        showAlert({
          text: REQ_FAILD,
          type: "error",
        }),
      )
    }
  }

  return (
    <div className="payment-details-container">
      <div className="top-section space-between">
        <Typography variant="h4">{PAYMENT_DETAILS_TITLE}</Typography>
        {!isMobile && (
          <Button
            className="primary-btn add-card-btn"
            variant="contained"
            onClick={() =>
              dispatch(showModal({ activeModal: ModalTypes.ADD_CARD_MODAL }))
            }
          >
            {PAYMENT_ADD_CARD_BTN}
          </Button>
        )}
      </div>
      <TableContainer
        component={Paper}
        className={"payment-details-table__container"}
      >
        <Table
          aria-label="payment details table"
          className={"payment-details-table"}
        >
          <TableHead>
            <TableRow>
              <TableCell>{PAYMENT_DETAILS_TITLE}</TableCell>
              <TableCell>{PAYMENT_TABLE_NUMBER}</TableCell>
              <TableCell align="center">{PAYMENT_TABLE_VALIDITY}</TableCell>
              <TableCell align="center">{PAYMENT_TABLE_PRIMARY}</TableCell>
              <TableCell align="center">{PAYMENT_TABLE_ACTIVE}</TableCell>
              <TableCell align="center">{PAYMENT_TABLE_ACTIONS}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {creditCardList?.map((card: CreditCardList) => (
              <TableRow
                key={card.creditCardToken}
                className={"payment-details-table__row"}
              >
                <TableCell component="th" scope="row">
                  {card.last4Digits}
                </TableCell>
                <TableCell component="th" scope="row">
                  {card.last4Digits}
                </TableCell>
                <TableCell align="right">{card.creditValidity}</TableCell>
                <TableCell align="right">
                  {card.isDefault && <CheckRoundedIcon />}
                </TableCell>
                <TableCell align="right">
                  {card.isActive && <CheckRoundedIcon />}
                </TableCell>
                <TableCell
                  align="right"
                  style={{ flexDirection: "row", display: "flex" }}
                  className={"payment-details-table__actions"}
                >
                  {!card.isDefault && (
                    <Button
                      style={{ fontSize: "12px" }}
                      color="primary"
                      onClick={() => setDefualt(card.paymentMethodId)}
                    >
                      {SET_AS_PRIMARY}
                    </Button>
                  )}

                  <Button
                    style={{ fontSize: "12px" }}
                    color="primary"
                    onClick={() =>
                      setActive(card.paymentMethodId, !card.isActive)
                    }
                  >
                    {card.isActive ? DEACTIVATE : ACTIVATE}
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <br />
      {isMobile && (
        <Button
          className="primary-btn add-card-btn"
          variant="contained"
          onClick={() =>
            dispatch(showModal({ activeModal: ModalTypes.ADD_CARD_MODAL }))
          }
        >
          {PAYMENT_ADD_CARD_BTN}
        </Button>
      )}
    </div>
  )
}
